<template>
	<div class="shop" v-loading="loading">
		 <div class="shop_box">
            <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span>
                > 
                <span class="span2">更多服务 </span>
                > 
                <span class="span2">积分商城</span>
             </div>
             <div class="shop_list">
                <div class="shop_item" v-for="(item,index) in list" :key="index" @click="handle_detial(item)">
                    <div class="shop_img">
                        <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                         <img :src="item.thumb" alt="">
                         
                    </div>
                    <div class="item_info">
                        <div class="titles">{{ item.title }}</div>
                        <div class="price_btns">
                            <div class="prices">
                                {{ item.jifen }}
                                <span>积分</span>  
                                {{ item.money!=0?'+':'' }}
                                {{ item.money!=0? item.money:'' }}
                                <span v-if="item.money!=0">元</span>  
                            </div>
                            <div class="btns" >兑换</div>
                        </div>
                    </div>

                </div>
                <div class="shop_item2" v-for="(item,index) in 4" :key="index">
                </div>
            </div>
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns"  @click="handle_pages(10)">尾页</div>
            </div>
         </div>
       
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	 
	export default {
		components: {
		 
		},
		name: "index",
		data() {
			return {
				loading:false,
                urls:'',
                list:[],
                total:0,
                pages:{
                    page:1,
                    limit:16,
                },
			}
		},
		computed: {
			 
		},
		watch: {
			
		},
		created() {
            this.get_list()
		},
		methods: {
		    handleSizeChange(e){
                console.log('条数',e)            
            },
            handleCurrentChange(e){
                console.log('页数',e)
            },
            handle_pages(i){
                console.log('首页尾页',i)
                this.pages.page=i
            },
            get_list(){
                this.urls=window.location.host+'/uploads/'
                this.loading = true
                this.$api("jifenShop", {
                    ...this.pages,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('积分商品列表',res)
                    if (res.code == 1) {
                        this.list=res.data.data
                        this.total=res.data.total
                        this.last_page=res.data.last_page
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
            handle_detial(item){
                this.$router.push({
                    path:'/shop_detial',
                    query:{
                        id:item.id
                    }
                })
            },


		},

	}
</script>
<style scoped lang="less">
	.shop {
		background: #F5F5F5;
        padding-bottom: 100px;
        padding-top: 20px;
        .shop_box{
            width: 1440px;
            margin: auto;
            .title_box{
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                .span1{
                    cursor: pointer;
                    margin-right: 10px;
                }
                .span2{
                    cursor: pointer;
                    margin-left: 10px;
                }
                img{
                    margin-right: 10px;
                }
            }
            .shop_list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .shop_item{
                    width: 342px;
                    height: 337px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #D7D7D7;
                    margin-bottom: 24px;
                    cursor: pointer;
                    .shop_img{
                        width: 100%;
                        height: 238px;
                        img{
                            width: 100%;
                            height: 238px;
                        }
                    }
                    .item_info{
                        height: 100px;
                        padding: 16px;
                        display: flex;
                        align-content: space-between;
                        flex-wrap: wrap;
                        .titles{
                            width: 100%;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                        
                        }
                        .price_btns{
                            width: 100%;
                           
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .prices{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size:20px ;
                                color: #FD4C5C;
                                span{
                                    font-size: 12px;
                                }
                            }
                            .btns{
                                width: 64px;
                                height: 24px;
                                background: #377CFD;
                                border-radius: 3px 3px 3px 3px;
                                text-align: center;
                                line-height: 24px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFFFFF;

                          }
                        }
                    }
                }
                .shop_item2{
                    width: 342px;
                }
            }
            .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: center;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                        }
                        .active{
                            background-color: #377CFD;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
        }
        
	}
</style>